import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const Botones=()=>{

    let history = useHistory();

    const BotonCrearSubsede = () =>{

       const onClickBtnCrearSubsede = () =>{
            history.push("/subsede/crear");
        }
        return(
            <Button
            type="primary"
            icon={<PlusOutlined/>}
            onClick={onClickBtnCrearSubsede}            
            >
                Crear Subcentro de costo
            </Button>
        )

    }
    return(
        <React.Fragment>
            <BotonCrearSubsede/>
        </React.Fragment>
    )

}
export default Botones;